import { decorate, extendObservable, computed } from "mobx";
import Core from "Core";
import moment from "moment";

export class Customer extends Core.Stores.Model {
  constructor(store, id) {
    super(store, id);

    extendObservable(this, {
      Name: null,
      Telephone: null,
      Email: null,
      AddressLine1: null,
      PostalCode: null,
      City: null,
      CountryId: "BE",
      InternalRemark: null,
      PasswordExpirationTime: 1, // Set the standard to 1 -> Never
    });
  }

  get asJSON() {
    return {
      Id: this.Id,
      Name: this.Name,
      Telephone: this.Telephone,
      Email: this.Email,
      AddressLine1: this.AddressLine1,
      PostalCode: this.PostalCode,
      City: this.City,
      CountryId: this.CountryId,
      InternalRemark: this.InternalRemark,
      PasswordExpirationTime: this.PasswordExpirationTime,
      LastUpdated: this.LastUpdated instanceof moment ? this.LastUpdated.format() : null,
    };
  }

  isValid() {
    let isValid = true;
    if (
      this.Id === null ||
      this.Id === undefined ||
      this.Id === "" ||
      this.Name === null ||
      this.Name === undefined ||
      this.Name === "" ||
      this.Email === null ||
      this.Email === undefined ||
      this.Email === "" ||
      this.AddressLine1 === null ||
      this.AddressLine1 === undefined ||
      this.AddressLine1 === "" ||
      this.City === null ||
      this.City === undefined ||
      this.City === "" ||
      this.CountryId === null ||
      this.CountryId === undefined ||
      this.CountryId === "" ||
      this.PasswordExpirationTime === null ||
      this.PasswordExpirationTime === undefined ||
      this.PasswordExpirationTime === ""
    )
      isValid = false;
    return isValid;
  }

  parseAsDate(key) {
    return key === "LastUpdated";
  }
}

decorate(Customer, {
  asJSON: computed,
});



// WEBPACK FOOTER //
// ./src/Stores/DataStore/Models/Customer.js